import React, {useState} from 'react';
import styles from "../EducationWorkProgramsBooksTable.module.css";
import BookSearchItem from "../Item";
import BookSearchCompactItem from '../CompactItem';

const BooksList = ({item, data, booksInfo, onHandleDelete, isCompactView}) => {
    const [isVisible, setVisible] = useState(true);


    return (
        <div>
            {item.list.length > 0
                ?
                <>
                    <div
                        onClick={() => setVisible(!isVisible)}
                        className={styles.tabName}
                    >
                        <span>{item.name}</span>
                        <span className={styles.collapse}>{isVisible ? "свернуть" : "развернуть"}</span>
                    </div>

                    {isVisible &&
                        <div>
                            {item.list.map((item, index) => <React.Fragment key={`bookListItem${index}`}>
                                    {isCompactView ? (
                                        <BookSearchCompactItem item={item} index={index} data={data} booksInfo={booksInfo}
                                                               onHandleDelete={onHandleDelete}/>
                                    ) : (
                                        <BookSearchItem item={item} index={index} data={data} booksInfo={booksInfo}
                                                        onHandleDelete={onHandleDelete}/>
                                    )}
                                </React.Fragment>
                            )}
                        </div>

                    }
                </>

                :
                <p>Записи отсутствуют</p>
            }

        </div>
    );
};


export default BooksList;